var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 9,
    viewBox: "0 0 20 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63223 3.23963C1.26033 3.1477 1 3.03279 1 2.80296V2.77998V0.899994L10 3.06036L19 0.899994V2.77998V2.80296C19 3.05577 18.7025 3.17068 18.3678 3.23963L10 5.39999L1.63223 3.23963Z",
    stroke: "#1B2646",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00009 3.14999V5.47997V5.50296C2.00009 5.73278 2.23439 5.8477 2.5691 5.93963L10.1001 7.64999L17.6311 5.93963C17.9323 5.87068 18.2001 5.75577 18.2001 5.50296V5.47997V3.14999",
    stroke: "#1B2646",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 4.99997C12.9999 6.65682 11.6568 7.99997 9.99991 7.99997C8.34305 7.99997 6.99991 6.65682 6.99991 4.99997C6.99991 3.34312 8.34305 1.99997 9.99991 1.99997C11.6568 1.99997 12.9999 3.34312 12.9999 4.99997Z",
    fill: "#1B2646",
    stroke: "#1B2646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotsDark);
export default __webpack_public_path__ + "static/media/pilots-dark.1085e982512f9bb8d20a90ca439f10f1.svg";
export { ForwardRef as ReactComponent };